import { captureException } from "@sentry/react";
import { AxiosInstance } from "axios";
import { Dispatch } from "redux";
import { IStateTree } from "../../interfaces";
import { showNotification } from "../../notification/actions";
import { PackActionTypes } from "../models/packActions";

import { DELETE_PLAN } from "../types";

export default (data: { planId: string, index: number }, callback: () => void) =>
    async (dispatch: Dispatch<PackActionTypes>, getState: () => IStateTree, api: AxiosInstance) => {
    try {
        await api.post("/delete-plan", data);
        dispatch({
            type: DELETE_PLAN,
            payload: { index: data.index },
        });
        callback();
    } catch (error) {
        dispatch(showNotification(error.toString(), "warning"));
        captureException(error);
    }
};